import { isNil } from "lodash"
import { DateTime } from "luxon"

export const sleep = (ms: number) =>
  new Promise<void>(resolve => setTimeout(resolve, ms))

export const sanitizeDateInput = (value: unknown) => {
  if(isNil(value)) return undefined

  switch(typeof value) {
    case "number":
      return value
    case "string":
      return value.trim().length > 0 ?
        DateTime.fromFormat(value, "yyyy-MM-dd").toMillis() :
        undefined
    default:
      return NaN
  }
}

export const sanitizeNumberInput = (value: unknown) => {
  if(isNil(value)) return undefined

  switch(typeof value) {
    case "number":
      return value
    case "string":
      return value.trim().length > 0 ?
        Number(value) :
        undefined
    default:
      return NaN
  }
}
